/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Filltype1Inputs */

const de__field_filltype1 = /** @type {(inputs: _Field_Filltype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füllungstyp`)
};

/**

* @param {_Field_Filltype1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_filltype1 = /** @type {((inputs?: _Field_Filltype1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Filltype1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_filltype1(inputs)
});
export { _field_filltype1 as "_field_fillType" }